import type { ReactNode } from 'react';
import React from 'react';
import { Text } from 'Components/frameworks/text/Text';
import { Title } from 'Components/frameworks/title/Title';
export type ProductFeatureDetailMainInformationProps = {
  className?: string;
  duration?: {
    description: string;
    disclaimer?: string;
    label?: string;
  };
  items?: Array<{
    description?: string;
    label?: string;
    note?: string;
  }>;
  note?: string;
  smallTitle?: ReactNode;
  title?: string;
};
export function ProductFeatureDetailMainInformation(
  props: ProductFeatureDetailMainInformationProps,
) {
  const { className, duration, items = [], note, smallTitle, title } = props;
  const durationInfo = (duration ?? {}) as NonNullable<
    ProductFeatureDetailMainInformationProps['duration']
  >;

  if (!durationInfo.description && !items.length) {
    return null;
  }

  return (
    <section className={className}>
      <Title className="mb-20 sm:mb-15" hLevel={3} theme="title-brand-n3">
        {smallTitle ? (
          <span className="flex w-full flex-col sm:flex-row sm:justify-between">
            {title} {smallTitle}
          </span>
        ) : (
          title
        )}
      </Title>
      <div className="w-full pe-10 sm:w-1/2">
        {!!durationInfo.description && (
          <div className="text-1 mb-10 mt-10">
            {!!durationInfo.label && <span className="font-bold">{`${durationInfo.label}: `}</span>}
            {durationInfo.description}
            {!!durationInfo.disclaimer && (
              <div className="text-12 leading-normal text-black">{durationInfo.disclaimer}</div>
            )}
          </div>
        )}
        {!!items.length && (
          <ul className="text-14 leading-normal text-black">
            {items.map((item) => {
              return (
                (item.description || item.note) && (
                  <li className="my-5 list-disc py-10" key={item.label}>
                    {!!item.label && <div className="font-bold">{item.label}</div>}
                    {!!item.description &&
                      (typeof item.description === 'string' ? (
                        <Text className="mb-5 inline-block" text={item.description} />
                      ) : (
                        item.description
                      ))}
                    {!!item.note && <small className="block">{item.note}</small>}
                  </li>
                )
              );
            })}
          </ul>
        )}
        {!!note && <div className="mt-15 text-12 italic">{note}</div>}
      </div>
    </section>
  );
}
